<template>
  <div>
    <div class="thumb-example">
      <!-- swiper1 -->
      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop"  v-if="swiperReset">
        <swiper-slide class="slide-1" v-for="item in bigImg" :key="item.id">
          <div class="slide-1-box">
            <img :src="item.src" style="width:100%" alt="" />
          </div>
        </swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs" v-if="swiperReset">
        <swiper-slide
          class="slide-thumb-item"
          style="height:100px;"
          :style="{'width': thumbsWidth + '%'}"
          v-for="item in bigImg"
          :key="item.id"
        >
          <img style="width:100%;height:100px;" :src="item.src" alt="" />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bigImg: {
      type: Array,
      required: true
    }
  },
  watch: {
    bigImg: {
      deep: true,
      immediate: true,
      handler (newValue, oldValue) {
        this.swiperReset = false
        this.$nextTick(() => {
          this.thumbsWidth = 100 / this.bigImg.length
          this.swiperOptionTop.loopedSlides = this.bigImg.length
          this.thumbsWidth = 100 / this.bigImg.length
          this.swiperReset = true
          setTimeout(() => {
            const swiperTop = this.$refs.swiperTop.swiper
            const swiperThumbs = this.$refs.swiperThumbs.swiper
            swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
          }, 100)
        })
      }
    }
  },

  mounted () {
    // 实现swiper双向控制
    // this.$nextTick(() => {
    //   this.swiperOptionTop.loopedSlides = this.bigImg.length
    //   this.thumbsWidth = 100 / this.bigImg.length
    //   const swiperTop = this.$refs.swiperTop.swiper
    //   const swiperThumbs = this.$refs.swiperThumbs.swiper
    //   swiperTop.controller.control = swiperThumbs
    //   swiperThumbs.controller.control = swiperTop
    // })
  },
  data () {
    return {
      swiperReset: false,
      thumbsWidth: 100 / this.bigImg.length,
      swiperOptionTop: {
        loop: true,
        updateTranslate: true, // 当所有的内嵌图像（img标签）加载完成后Swiper会重新初始化。
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper父元素时，自动初始化swiper
        loopedSlides: 7, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        loop: true,
        updateTranslate: true, // 当所有的内嵌图像（img标签）加载完成后Swiper会重新初始化。
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper父元素时，自动初始化swiper
        loopedSlides: 7, // looped slides should be the same
        spaceBetween: 10,
        loopAdditionalSlides: 100,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      }
    }
  },

  methods: {}
}
</script>

<style lang="scss" scoped>
h3 {
  margin: 20px 0 0 10px;
}
.thumb-example {
  width: 100%;
  margin-top: 20px;
  // background: #000;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.slide-1-box{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 600px;
  overflow: hidden ;
   img{
     height: fit-content;
   }
}
.gallery-top {
  // height: 80% !important;
  height: 600px;
  width: 100%;
}
.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0px;
  width: 100%;
  margin-left: 2px;
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    left: 0px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    background: #fff;
    width: 45px;
    text-align: center;
    height: 101px;
    top: 26%;
    div {
      margin-top: 30px;
      background: rgb(207, 205, 205);
      height: 45px;
      border-radius: 50%;
      img {
        margin: 7px 0 0 2px;
        width: 30px;
      }
    }
  }
  .swiper-button-next:hover div {
    background: rgb(189, 186, 186);
  }
  .swiper-button-prev:hover div {
    background: rgb(189, 186, 186);
  }
}

.gallery-thumbs .slide-thumb-item {

  height: 80px;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}

@media (max-width: 575.98px) {
  .gallery-thumbs{
    display: none !important;
  }
  .gallery-top{
    height: fit-content;
  }
  .slide-1-box{
    height: 300px !important;
  }
}
</style>




// WEBPACK FOOTER //
// Gallery.vue?d33fac50